import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, catchError, tap, throwError, switchMap } from 'rxjs';
import { AuthService } from './Services/auth.service';
import { ApiService } from './Services/api.service';

// Functional HTTP interceptor
export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {

  const authService = inject(AuthService);
  const apiService = inject(ApiService);
  const token = authService.getAccessToken(); // Retrieve JWT token

  // Clone request and add Authorization header if token exists
  const authReq = token
    ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
    : req;

  return next(authReq).pipe(
    tap(event => {
      // You can log or modify responses here
    }),
    catchError(err => {
      if (err.status === 401) {
        if (err.status === 401 && err.url.includes('/api/v1/login/refresh-token')) {
          authService.logout('type1', false);
        } else {
          // Try refreshing token
          return apiService.refreshToken().pipe(
            switchMap((res) => {
              authService.setAccessToken(res.accessToken);
              const newToken = authService.getAccessToken();
              return next(req.clone({
                setHeaders: { Authorization: `Bearer ${newToken}` }
              }));
            }),
            catchError(error => {
              if (error.status === 401) {
                authService.logout('type1', false);
              }
              return throwError(() => error);
            })
          );
        }
      }
      return throwError(() => err);
    })
  );
};